<template>
  <modal
    id="contact-edit-modal"
    :confirm-text="'Save'"
    confirm-class="btn-primary"
    @confirm="handleSubmit"
    :close-text="'Cancel'"
    close-class="btn-default pull-left"
    :isLoading="isLoading"
  >
    <template slot="title">{{ modalTitle }}</template>
    <form slot="body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="author-name">Name: (Required)</label>
          <input
            v-model="localName"
            type="text"
            class="form-control"
            id="author-name"
            placeholder="Add Character Name"
          />
        </div>
        <div class="form-group col-md-12">
          <label for="author-title">Title: (Required)</label>
          <input
            v-model="localTitle"
            type="text"
            class="form-control"
            id="author-title"
            placeholder="Add Character's Position/Role"
          />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="author-color">Icon Color:</label>
          <theme-dropdown
            selection-id="author-color"
            v-model="localTheme"
            @select="handleSelectTheme"
          ></theme-dropdown>
        </div>
      </div>
    </form>
  </modal>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import ThemeDropdown from './ThemeDropdown';

  export default {
    components: {
      ThemeDropdown,
    },

    props: {
      nameTagKey: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
      FK_authorThemeKey: {
        type: Number,
        default: null,
      },
      authorKey: {
        type: Number,
        default: null,
      },
    },

    data() {
      return {
        localName: this.nameTagKey,
        localTitle: this.title,
        localTheme: this.FK_authorThemeKey,
        requiredFields: {
          localName: 'Name',
          localTitle: 'Position/Role',
        },
        isLoading: false,
      };
    },

    watch: {
      authorKey(newKey, oldKey) {
        if (newKey !== oldKey) {
          this.localName = this.nameTagKey;
          this.localTitle = this.title;
          this.localTheme = this.FK_authorThemeKey;
        }
      },
    },

    computed: {
      modalTitle() {
        return this.authorKey ? 'Edit Character' : 'Add Character';
      },
    },

    methods: {
      ...mapActions(['SET_MILESTONE']),
      ...mapActions('editMode/characters', ['createAuthor', 'updateAuthor']),

      handleSelectTheme(authorThemeKey) {
        this.localTheme = authorThemeKey;
      },

      async handleSubmit() {
        const invalidKey = this.validateForm();

        if (invalidKey) return alert(`Invalid ${invalidKey}`);

        const payload = {
          nameTagKey: this.localName,
          title: this.localTitle,
          FK_versionKey: this.$route.params.resourceKey,
          FK_authorThemeKey: this.localTheme,
        };

        this.isLoading = true;
        // set milestone notif
        if (this.localName.length > 0 && this.localTitle.length > 0) {
          this.characterCreationNotification();
        }

        if (this.authorKey) {
          await this.updateAuthor({ ...payload, authorKey: this.authorKey });
        } else {
          await this.createAuthor(payload);
          this.clearForm();
        }

        this.isLoading = false;
        $('#contact-edit-modal').modal('hide');
      },

      characterCreationNotification() {
        this.SET_MILESTONE({
          message: 'Create First Character',
          tooltipDesc: this.tooltips.milestones['4'],
          timeout: 8000,
          milestoneKey: 4,
        });
      },

      clearForm() {
        this.localName = '';
        this.localTitle = '';
        this.localTheme = null;
      },

      validateForm() {
        const invalidKey = Object.keys(this.requiredFields).find((k) => {
          if (this.$data.hasOwnProperty(k) && this.$data[k].length === 0) return true;
        });

        return this.requiredFields[invalidKey];
      },
    },
  };
</script>
